export default __webpack_public_path__ + "static/media/email.e28b6534.jfif";